module.exports = __webpack_public_path__ + "static/img/service-06.89b58f3b.png";